import { useEffect, useState } from "react";
import moment from "moment";

const Timer = ({ date }) => {
  const [timer, setTimer] = useState("00:00:00");

  useEffect(() => {
    const update = () => {
      const diff = moment.duration(moment().diff(moment(date)));

      const d = diff.days();
      const h = String(diff.hours()).padStart(2, "0");
      const m = String(diff.minutes()).padStart(2, "0");
      const s = String(diff.seconds()).padStart(2, "0");

      if (d > 0) {
        setTimer(`${d}d ${h}:${m}:${s}`);
      } else {
        setTimer(`${h}:${m}:${s}`);
      }
    };

    update();
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, [date]);

  return <span>{timer}</span>;
};

export default Timer;
